import { useTranslation } from 'react-i18next';
import PaginaTexto from '../Compartido/PaginaTexto.jsx';
import urlLogo from '../Compartido/urlLogo.js';

const TextosMarca = ({ eltexto, ruta, lang, config }) => {

    const { t } = useTranslation();

    const imagen = eltexto.imagen ? ruta + "/marcas/" + eltexto.id + "/imagen/" + eltexto.imagen : null;

    return (
        <PaginaTexto
            titulo={eltexto.nombre}
            eyebrow={t("Marca")}
            imagen={imagen}
            logo={urlLogo(config, ruta)}
            html={eltexto.texto[lang]}
        />
    );
}

export default TextosMarca;
